import React, { useRef, useState, useEffect } from "react";
import Layout from "components/layout/Layout";
import localization from "assets/localization/localization";
import callWebService, { callTypes } from "services/utils/networks/network";
import {
  checkEmpty,
  dateParser
} from "services/utils/commonFunctions/CommonFunctions";
import Config from "services/config/config";
import ConstVar from "constants/const";
import { trim, uniq } from "lodash";
import CustomModal from "components/modal/modal";
import CopyPaste from "components/copypaste/Copypaste";
import { BaseUrl } from "context/baseUrl/baseUrl";
import FormSection from "components/form/FormSection";
import Loader from "components/loader/loader";
import MainLayout from "components/mainLayout/MainLayout";
import JsonFormatter from "react-json-formatter";
import DropdownFilter from "components/input/dropdown/dropDownFilter";

const PaymentLog = ({ match }) => {
  const [isCheck, setIsCheck] = useState([]);
  const [smallModal, setSmallModal] = useState({hover1: false, hover2: false, show: false});
  const [modalShow, setModalShow] = useState(false);
  const [activeComponent, setActiveComponent] = useState();
  const [isLoading, setisLoading] = useState(false);
  const [applicationCode, setApplicationCode] = useState("");
  const [response, setResponse] = useState(null);
  const [request, setRequest] = useState({});
  const [pageNo, setPageNo] = useState(1);
  const [perPageRecord, setPerPageRecord] = useState(10);
  const [totalRecord, setTotalRecord] = useState(0);
  const [paymentLogList, setPaymentLogList] = useState([]);
  const scrl = useRef(null);

  useEffect(()=>{
    (async () => {
    paymentLogApi(1);
   })();
  },[])

  const paymentLogApi = async (page, handleRecordPerPage) => {
    setisLoading(true);
    const data={
      pageSize: handleRecordPerPage ? handleRecordPerPage : perPageRecord,
      pageNo: page ? page : 1,
      searchName: applicationCode ? trim(applicationCode) : "",
    }

    const res = await callWebService(
      callTypes.post,
      data,
      Config.paymentLog
    );
      console.log('dddddddddddddd', res.data)
    if (res?.data?.data?.get_payment_log_list) {
      setPaymentLogList(res?.data?.data?.get_payment_log_list);
      setPerPageRecord(res?.data?.data?.pagination?.pre_page_records);
      setTotalRecord(res?.data?.data?.pagination?.total_rows);
      setPageNo(page ? page : res?.data?.data?.pagination?.current_page);
      setisLoading(false);
    }
  }

  const renderHeader = () => {
    let headerElement = [
        "S. No.",
        "Application No",
        "Encode Request/Response",
        "Decode Request/Response",
        "Http Status Code",
        "Response Url",
        "Response Payment Id",
        "Status",
        "Created At",
        "Updated At"
      ];

    return headerElement.map((key, index) => {
      return <th key={index}>{key}</th>;
    });
  };

  const encodeReqRes = (data) => {
    setModalShow(true);
    if (data?.encode_request) {
      const req = trim(
        typeof data?.encode_request === "object"
          ? JSON.stringify(data?.encode_request)
          : data?.encode_request
      );
      setRequest(req);
    }
    if (data?.encode_response) {
      const res = trim(
        typeof data?.encode_response === "object"
          ? JSON.stringify(data?.encode_response)
          : data?.encode_response
      );
      setResponse(res);
    }
  };

  const decodeReqRes = (data) => {
    setModalShow(true);
    if (data?.decode_request) {
      const req = trim(
        typeof data?.decode_request === "object"
          ? JSON.stringify(data?.decode_request)
          : data?.decode_request
      );
      setRequest(req);
    }
    if (data?.decode_response) {
      const res = trim(
        typeof data?.decode_response === "object"
          ? JSON.stringify(data?.decode_response)
          : data?.decode_response
      );
      setResponse(res);
    }
  };
  
  const closeModal = () => {
    setModalShow(false);
    setResponse("");
    setRequest("");
  };

  const testJSON = (text) => {
    if (typeof text !== "string") {
      return false;
    }
    try {
      var json = JSON.parse(text);
      return json;
    } catch (error) {
      return false;
    }
  };

  const jsonStyle = {
    propertyStyle: { color: "red" },
    stringStyle: { color: "green" },
    numberStyle: { color: "darkorange" },
  };

  const recordsPerPage = [
    { records_id: 10, records_value: 10 },
    { records_id: 20, records_value: 20 },
    { records_id: 30, records_value: 30 },
    { records_id: 50, records_value: 50 },
  ];

  const showText = (data) =>{
    let text;
    if (data === 1) {
        text = "Complete";
    } else {
        text = "Failed";
    }
    return text;
  }

  const renderBody = () => {  
   
    return (
      !checkEmpty(paymentLogList) &&
      paymentLogList.map((val, index) => {
        return (
            <tr key={index}>
            <td>{pageNo === 1 ? index + 1 : (pageNo - 1) * perPageRecord + index + 1 }</td>       
            <td>{val.application_no}</td>
            <td>
              {" "}
              <a
                style={{ cursor: "pointer" }}
                className="anchorNew"
                onClick={() => encodeReqRes(val)}
              >
                <u> Request / Response</u>
              </a>
            </td>
            <td>
              {" "}
              <a
                style={{ cursor: "pointer" }}
                className="anchorNew"
                onClick={() => decodeReqRes(val)}
              >
                <u> Request / Response</u>
              </a>
            </td>
            <td>{val.http_status_code}</td>
            <td>{val.response_url}</td>
            <td>{val.response_payment_id}</td> 
            <td>{showText(val.status)}</td> 
            <td>
              {val.created_at
                ? dateParser(
                  val.created_at,
                    `${ConstVar.DATE_FORMAT}`
                  )
                : null}
              <br />
              {val.created_at
                ? dateParser(
                  val.created_at,
                    `${ConstVar.TIME_FORMAT}`
                  )
                : null}
            </td>
            <td>
              {val.updated_at
                ? dateParser(
                  val.updated_at,
                    `${ConstVar.DATE_FORMAT}`
                  )
                : null}
              <br />
              {val.updated_at
                ? dateParser(
                  val.updated_at,
                    `${ConstVar.TIME_FORMAT}`
                  )
                : null}
            </td>          
          </tr>
        );
      })
    );
  };

  const nextPage = async (page) => {
    setisLoading(true);
    paymentLogApi(page);
    setisLoading(false);
  }

  const handleRecordsPerPage = async (event) => {
    setPageNo(1);
    setisLoading(true);
    paymentLogApi(1, parseInt(event.target.value));
  };

  const searchProductCode = () => {
    setPageNo(1);
    paymentLogApi(1);
  }

  const resetProductCode = () => {
    window.location.reload();
  }

  const handleApplicationCode = (e) => {
    const value = e.target.value;
    setApplicationCode(value);
  }

  const inputSearch = () => {
    return (
      <>
        <div style={{ float: "right", position: "relative" }}>
          {paymentLogList && paymentLogList.length > 0 ? (
            <b
              className="pagination-value"
              data-hovered={smallModal.hover1}
              style={{ cursor: "pointer" }}
              onMouseLeave={() => {
                setSmallModal({ ...smallModal, hover1: false, hover2: false });
              }}
              onMouseEnter={() => {
                setSmallModal({ ...smallModal, hover1: true, show: true });
              }}
            >
              {pageNo == 1 ? pageNo : (pageNo - 1) * perPageRecord + 1}-
              {pageNo * perPageRecord > totalRecord
                ? totalRecord
                : pageNo * perPageRecord}{" "}
              of {totalRecord}
            </b>
          ) : (
            <span className="pagination-value">0 - 0 of 0</span>
          )}
          &nbsp;
          {smallModal.hover1 && (
            <div
              className="small-modal"
              onMouseEnter={() => {
                setSmallModal({ ...smallModal, hover2: true });
              }}
              onMouseLeave={() => {
                setSmallModal({ ...smallModal, hover2: false, hover1: false });
              }}
            >
              <span
                className="small-modal-option"
                data-disabled={pageNo === 1 && true}
                onClick={() => {
                  nextPage(1);
                }}
              >
                Newest
              </span>
              <span
                className="small-modal-option"
                data-disabled={totalRecord <= pageNo * perPageRecord && true}
                onClick={() => {
                  nextPage(Math.ceil(totalRecord / perPageRecord));
                }}
              >
                Oldest
              </span>
            </div>
          )}
          <button
            className="pagination-button"
            onClick={() => nextPage(pageNo - 1)}
            title="Newer"
            data-disabled={pageNo <= 1 && true}
            disabled={pageNo <= 1}
          >
            {"<"}
          </button>
          &nbsp;
          <button
            className="pagination-button"
            onClick={() => nextPage(pageNo + 1)}
            title="Older"
            data-disabled={
              totalRecord <= pageNo * perPageRecord || paymentLogList.length === 0
            }
            disabled={
              totalRecord <= pageNo * perPageRecord || paymentLogList.length === 0
            }
          >
            {">"}
          </button>
        </div>
        &nbsp;&nbsp;
      </>
    );
  };
  const filterSearch = () => {};

  return (
    <BaseUrl.Provider value={{ baseUrl: match.url }}>
      <MainLayout activeComponent={activeComponent} match={match}>
        <Layout
          title="Payment Log List"
          isLoading={false}
          isGoback={true}
          className={"desktop-view"}
        >
          <FormSection
            search={true}
            inputSearch={inputSearch}
            filterSearch={filterSearch}
            sortBy={() => {}}
            isCheck={isCheck}
          >
            <div
              className="panel-card-table"
              ref={scrl}
              style={{ width: "100%", overflow: "auto" }}
            >
              <table id="employee" className="table table-bordered">
                <thead>
                  <tr>{renderHeader()}</tr>
                </thead>
                <tbody>{renderBody()}</tbody>
              </table>
            </div>
            <div style={{maxWidth: '150px'}}>
              <DropdownFilter o
                  ptIdKey="records_id"
                  optValueKey="records_value"
                  optionList={recordsPerPage}
                  placeholder="Records Per Page"
                  onChange={(event) => {
                    setPerPageRecord(event.target.value);
                    handleRecordsPerPage(event);
                  }}
                  value={perPageRecord}
               />
            </div>
          </FormSection>
          {modalShow && (
            <CustomModal
              show={modalShow}
              modalClose={closeModal}
              showHeader
              backdrop
            >
              <div className="modal-body chekdisplay">
                <div
                  className={
                    response !== "notification"
                      ? "panel-card panelcard"
                      : "panel-card"
                  }
                >
                  <div className="panel-heading pop">
                    {response !== "notification" ? (
                      <>
                        Request
                        <div style={{ float: "right" }}>
                          <CopyPaste data={request} />
                        </div>
                      </>
                    ) : (
                      "Notification Content"
                    )}
                  </div>
                  <div className="panel-body  mx-0 pop ">
                    <div className="panel-card-table ">
                      <div className="popupclass">
                        {testJSON(
                          request
                            ? request.toString().replace(/\\/g, "")
                            : "null"
                        ) ? (
                          <JsonFormatter
                            json={
                              request
                                ? request.toString().replace(/\\/g, "")
                                : "null"
                            }
                            tabWith={4}
                            jsonStyle={jsonStyle}
                          />
                        ) : request ? (
                          request.toString().replace(/\\/g, "")
                        ) : (
                          "null"
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                {response !== "notification" ? (
                  <div className="panel-card panelcard">
                    <div className="panel-heading pop">
                      Response
                      <div style={{ float: "right" }}>
                        <CopyPaste data={response} />
                      </div>
                    </div>
                    <div className="panel-body mx-0 pop ">
                      <div className="panel-card-table">
                        <div className="popupclass">
                          {testJSON(
                            response
                              ? response.toString().replace(/\\/g, "")
                              : "null"
                          ) ? (
                            <JsonFormatter
                              json={
                                response
                                  ? response.toString().replace(/\\/g, "")
                                  : "null"
                              }
                              tabWith={4}
                              jsonStyle={jsonStyle}
                            />
                          ) : response ? (
                            response.toString().replace(/\\/g, "")
                          ) : (
                            "null"
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null}
              </div>
            </CustomModal>
          )}
          <Loader isLoading={isLoading} />
        </Layout>
        <div className="mobile-view container">
          <h3>{localization.label.myLead}</h3>
          <div className="my-lead-wrap">
            {/* {!checkEmpty(dataList) &&
              dataList.map((data, index) => (
                <ApplicationBox data={data} key={index} history={history} />
              ))} */}
          </div>
        </div>
      </MainLayout>
    </BaseUrl.Provider>
  );
};

export default PaymentLog;
